<template>

    <div class="card card-default">
        <div class="card-header">
            <h1>Users</h1>
        </div>

        <div class="card-body user-data-panel">

            <div :class="['loadingSpinner', {'d-none' : !loadingState}]">
                <i class="fas fa-sync fa-3x fa-spin"></i>
            </div>

            <div :class="['data-container', {'panel-loading' : loadingState}]">

                <a class="btn btn-primary add-new-user" href="/users/create"><i class="fas fa-user-plus"></i> Create New User</a>

                <user-table-component :currentSort="this.sort.by"
                                      :currentSortDir="this.sort.direction"
                                      :rawData="this.users"
                                      v-on:page:set="changePage($event)"
                                      v-on:update:sort="updateSort($event)"
                />

            </div>

        </div>

    </div>

</template>

<script>
import axios from 'axios'
import UserTableComponent from './UserTableComponent'

export default {
    components: { UserTableComponent },
    data: function () {
        return {
            users: {},
            sort: {
                by: 'company_name',
                direction: 'asc',
            },
            loadingState: false
        }
    },

    mounted () {
        this.getUserList(1, false, this.sort.by, this.sort.direction)
    },

    methods: {
        getUserList (page, scrollToTable, sortBy, sortDirection) {
            this.loadingState = true

            if(scrollToTable) {
                document.querySelector('#user-data-table').scrollIntoView()
            }

            axios({
                method: 'post',
                url: '/company/users',
                data: {
                    page,
                    sortBy,
                    sortDirection
                }
            })
                .then(response => (this.users = response.data))
                .then(() => { this.loadingState = false })
                .catch(function (error) {
                    console.log(error)
                })
        },

        changePage (page) {
            this.getUserList(page, true, this.sort.by, this.sort.direction)
        },

        updateSort (payload) {
            this.sort.by = payload.by
            this.sort.direction = payload.direction

            this.getUserList(1, true, this.sort.by, this.sort.direction)
        },
    }
}

</script>
